import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { useDocumentTitle } from "@/lib/use-document-title";

export function NotFoundPage() {
  useDocumentTitle("Page not found");

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
      <h1 className="text-lg font-semibold">Page not found</h1>
      <Button asChild variant="outline">
        {/* "/" is HomeRedirect — the topmost page this role can open.
            Hardcoding /metrics sent support to a 403. */}
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
